/**
 * Created by huzhongchun on 2018/4/13.
 */
import React from 'react';
import { Route } from 'react-router-dom';
import AsyncComponent from 'components/public/asyncComponent';
import util from 'util/util';
import Index from 'containers/reading/index';

//由于页面过多，尽量使用AsyncComponent动态加载组件，避免主包过大
//每新加的路由，加上用途的注释
//路由的path最后一级名称必须有项目的前缀，以便区分不同的入口

let basePath = util.getRouteBaseUrl();
const routes = [
	{
		path: '/',
		exact: true,
		component: Index
	},
	{
		path: '/deep_night/reading_story_list', //交换：深夜故事
		exact: true,
		component: AsyncComponent(()=>import('containers/reading/exchange/deepNight/index'))
	},
	{
		path: '/golden_week/reading_collect', //交换：研究所X48CP 黄金周旅行交换活动
		exact: true,
		component: AsyncComponent(()=>import('containers/reading/exchange/goldenWeek/index'))
	},
	{
		path: '/good_night/reading_index', //晚安短信
		exact: true,
		component: AsyncComponent(()=>import('containers/reading/goodNight/getGoodNight/index'))
	},
	{
		path: '/good_night/reading_get_surprise', //晚安短信
		exact: true,
		component: AsyncComponent(()=>import('containers/reading/goodNight/getSurprise/index'))
	},
	{
		path: '/good_night/reading_end', //晚安短信
		exact: true,
		component: AsyncComponent(()=>import('containers/reading/goodNight/end/index'))
	},
	{
		path: '/good_night/reading_my_share', //晚安短信
		exact: true,
		component: AsyncComponent(()=>import('containers/reading/goodNight/myShare/index'))
	},
	{
		path: '/good_night/reading_share_landing', //晚安短信
		exact: true,
		component: AsyncComponent(()=>import('containers/reading/goodNight/shareLanding/index'))
	},
	{
		path: '/mock_login',
		exact: true,
		component: AsyncComponent(()=>import('containers/mockLogin/index'))
	},

	//NotFound必须放在最后面
	{
		path: '',
		exact: true,
		component: AsyncComponent(()=>import('containers/notFound/index'))
	}

];

const RouteWithSubRoutes = route => {
	let Component = route.component;
	return <Route
		render={props => (
			// pass the sub-routes down to keep nesting
			<Component {...props} routes={route.routes}/>
		)}
	/>;
};

let routesList = routes.map((route, i) => {
	route.path = basePath + ((route.path === '/' && basePath) ? '' : route.path);
	return <RouteWithSubRoutes key={i} {...route} />;
});
export default routesList;



// WEBPACK FOOTER //
// ./src/router/reading/routesList.js